import { sendViaPostMessage } from "../../utils/";
import { hyphenCaseToCamelCase } from "../../utils/string";
import { isValid, isEmpty, isInvalid } from "../../utils/validation";
import { EVENTS } from "../../constants/";
const {
  READY,
  FRAME_ACTIVATED,
  FRAME_FOCUS,
  FRAME_BLUR,
  FRAME_VALIDATION_CHANGED,
} = EVENTS;

function onFrameActivated(state, element) {
  sendViaPostMessage(FRAME_ACTIVATED, { element });

  const elementKey = hyphenCaseToCamelCase(element);
  const elementState = state[elementKey];
  elementState.loaded = true;
  elementState.touched = false;
  elementState.startingValidationStatus = elementState.validationStatus;

  if (isEveryFrameLoaded(state)) {
    sendViaPostMessage(READY, {});
  }
}

function isEveryFrameLoaded(state) {
  const { cardNumber, expiryDate, cvv, cvvHidden } = state;

  const isCvvLoaded = cvv.loaded || cvvHidden;
  return cardNumber.loaded && expiryDate.loaded && isCvvLoaded;
}

function onFocus(state, element, data) {
  sendViaPostMessage(FRAME_FOCUS, { element });

  const elementKey = hyphenCaseToCamelCase(element);
  const elementState = state[elementKey];

  elementState.startingValidationStatus = data.validationStatus;
}

function onBlur(state, element, data) {
  sendViaPostMessage(FRAME_BLUR, { element });

  const elementKey = hyphenCaseToCamelCase(element);
  const elementState = state[elementKey];

  const isEmptyOrInvalidAndDifferentFromInitialOnFirstEntry =
    !elementState.touched &&
    elementState.startingValidationStatus !== data.validationStatus &&
    (isInvalid(data.validationStatus) || isEmpty(data.validationStatus));

  if (isEmptyOrInvalidAndDifferentFromInitialOnFirstEntry) {
    sendViaPostMessage(FRAME_VALIDATION_CHANGED, {
      element,
      isValid: isValid(data.validationStatus),
      isEmpty: isEmpty(data.validationStatus),
    });
  }

  if (!elementState.touched) {
    elementState.touched = true;
  }
}

function onValueChanged(state, element, data) {
  const elementKey = hyphenCaseToCamelCase(element);
  const elementState = state[elementKey];

  elementState.validationStatus = data.validationStatus;
  elementState.value = data.value;

  const isValidOnFirstEntry =
    !elementState.touched &&
    data.previousValidationStatus !== data.validationStatus &&
    isValid(data.validationStatus);

  const isEmptyOrInvalidAfterValidOnFirstEntry =
    !elementState.touched &&
    isValid(data.previousValidationStatus) &&
    (isInvalid(data.validationStatus) || isEmpty(data.validationStatus));

  const isPostTouchedChange =
    elementState.touched &&
    data.previousValidationStatus !== data.validationStatus;

  if (
    isValidOnFirstEntry ||
    isEmptyOrInvalidAfterValidOnFirstEntry ||
    isPostTouchedChange
  ) {
    sendViaPostMessage(FRAME_VALIDATION_CHANGED, {
      element,
      isValid: isValid(data.validationStatus),
      isEmpty: isEmpty(data.validationStatus),
    });
  }
}

export { onFrameActivated, onFocus, onBlur, onValueChanged };
